/**
 * Configurations for the table.
 * The key column is important to be configured.
 * type should include the column name and the data type to render.
 */
const config = {
  pageSize: 50,
  stockCheck: true,
  stockExemptIds: ['999970', '999971', '999972'],
  keyColumn: 'ID',
  stockColumn: 'Stock\r',
  priceColumn: 'Precio',
  quantityColumn: 'Cantidad',
  brandColumn: 'Marca',
  productColumn: 'Producto',
  promoColumn: 'Promo',
  sizeColumn: 'Tamaño',
  searchCriteria: {
    brand: 'Marca',
    product: 'Producto',
  },
  format: {
    Precio: 'money',
    Subtotal: 'money',
    Total: 'money',
  },
  style: {
    Precio: 'right',
    'Stock\r': 'right',
    Subtotal: 'right',
    Cantidad: 'right',
    Promo: 'right',
  },
  noMobile: {
    ID: true,
  },
  hidden: {},
  locales: {
    currency: 'ARS',
    region: 'es-AR',
  },
  cart: {
    columns: ['Cantidad', 'Subtotal', ''],
    actionColumns: [''],
    hidden: {
      'Stock\r': true,
      ID: true,
    },
  },
};

export default config;
